import { useMediaQuery } from 'react-responsive';

import { Breakpoints } from '@/hooks';

export const useIsMobileHeaderViewport = () =>
  useMediaQuery({
    query: `(max-width: ${Breakpoints.tabletSm - 1}px)`,
  });
